import format from 'date-fns/format';
import { set, subDays } from 'date-fns';
import { DAY } from 'Utils/Pagination/usePagination';
import { DATE_FORMATS } from 'Utils/formats';
import confinesDescriptions from '../ConfinesForm/confinesDescriptions';

export const DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm";

export const TIMESERIES_TABLE_TYPE = 'timeseries';
export const DIRTY_DATA_TABLE_TYPE = 'dirty-data';
export const REPORT_DATA_TABLE_TYPE = 'report';

export const VIEW_TABLE = 'table';
export const VIEW_GRAPH = 'graph';

export const SOURCE_TYPE_DATASOURCE = 'DATASOURCE';
export const SOURCE_TYPE_STATION = 'STATION';

export const initialParamsState = {
  // -7 дней от сегодняшней даты
  startDate: format(subDays(set(new Date(), { hours: 0, minutes: 0, seconds: 1 }), 7), DATE_TIME_FORMAT),
  endDate: format(new Date(), DATE_TIME_FORMAT),
  pageSize: DAY,
  view: VIEW_TABLE,
};

export const isTrue = (value) => value === 'true';

export const transformToArray = (object) => Object.keys(object).map((key) => [format(new Date(key), DATE_FORMATS.timeseries.withSeconds), ...object[key]]);
export const transformToObject = (array) => array.reduce((acc, item) => {
  if (!Object.keys(acc).includes(item[0])) {
    acc[item[0]] = item.slice(1);
  }
  return acc;
}, {});

export const selectableConfines = confinesDescriptions
  .filter((el) => el.tagName !== 'timeError')
  .flatMap((el) => (el.tagName
    ? { label: el.name, value: el.tagName }
    : [
      { label: el.max.name, value: el.max.tagName },
      { label: el.min.name, value: el.min.tagName },
    ]));
